<template>
  
  <div class="ml-3 mt-3" style="width:790px">
 
    <!-- 封装弹框 -->
   
              <el-tabs v-model="activeIndex" @tab-click="handleTabClick" type="card">

                <el-tab-pane :label="$t('msg.회원')" name="tab1">
                  <el-form ref="form" :model="form" label-width="100px" v-loading="formLoading">
              <table class="table table-bordered myTable ">
                <tr>
                  <td width="50%">

                   
                     <el-form-item :label="$t('msg.아이디')" class="mb-0  formItem layerItem">
                  {{form.mem_id}}<span class="ml-2">{{form.id_txt}}</span><el-button type="primary" size="mini" class="ml-2" plain @click="add" style="padding:5px 8px">{{$t('msg.쪽지')}}</el-button><el-button type="primary" size="mini" class="ml-2" @click="bonOpen(1,form.mem_id,'1')" style="padding:5px 8px">{{$t('tableText.충환전')}}</el-button>
                  <el-button v-if="form.sitetype==3 || form.sitetype==2 " type="primary" size="mini" class="ml-2" plain @click="addRcom"  style="padding:5px 8px">{{$t('tableText.추천')}}</el-button>
                </el-form-item>
                  </td>
                  <td>
                     <el-form-item  :label="$t('msg.등급')"  class="mb-0 formItem layerItem">
                   <el-select :placeholder="$t('status.선택')" v-model="form.memState" size="mini" style="width:80px;" class="mr-2">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="color:#999">{{$t('tableText.상태')}}:</span>
                  <el-select :placeholder="$t('status.선택')" v-model="form.mem_status" size="mini" style="width:80px" class="ml-2">
                    <el-option
                    v-for="item in statusoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                  </el-select>

                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item  class="mb-0 formItem layerItem labelNone">
                    <template v-if="form.sitetype=='4'">
                      <div class="d-flex">
                        <div class="mr-2">
                          {{$t('msg.알잔액')}}:{{formatMoney(form.mem_cash)}}
                         </div>

                          <div class="mr-2">
                          {{$t('msg.카슬머니')}}:{{formatMoney(form.api_money)}}

                          <el-button type="default" :title="$t('msg.카슬머니갱신')"  size="mini" style="padding:2px;" class="mr-1" icon="el-icon-refresh" @click="apiMoney('')"></el-button>
                         </div>
                         <div>
                            <template v-if="form.sitetype=='1' || form.sitetype=='4'">{{$t('msg.카슬롤링')}}:</template><span class="ml-1 mr-1 text-primary">{{formatMoney(form.mem_eventmoney)}}</span>
                         </div>
                      </div>
                      </template>
                     
                   
                  
                  </el-form-item>

              


                  </td>
                  <td>
                    <el-form-item :label="$t('msg.상위')" class="mb-0 formItem layerItem">
                     <span style="color:#999">{{$t('msg.부본')}}</span> <span class="text-danger mr-2" @click="openId(form.b_code)" style="cursor:pointer">{{form.b_code}}</span>  <span style="color:#999">{{$t('msg.총판')}}</span> <span class="text-primary mr-2" @click="openId(form.a_code)"style="cursor:pointer">{{form.a_code}}</span>
                      <template v-if="form.sitetype=='1' || form.sitetype=='2' || form.sitetype=='3'"><span style="color:#999">{{$t('msg.추천인')}}</span> {{form.m_cp}}</template>
                      <template v-if="form.sitetype==='4'"><span style="color:#999">{{$t('msg.매장')}}</span><span @click="openId(form.c_code)" class="text-primary" style="cursor:pointer"> {{form.c_code}}</span></template>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item label="" class="mb-0 formItem layerItem labelNone">
                      <div class="d-flex">
                        <div class="mr-2">{{$t('msg.파워머니')}}:{{formatMoney(form.power_cash)}}</div>
                        <div><span class="mr-1">{{$t('msg.파워롤링')}}:</span>{{formatMoney(form.power_ecash)}}</div>
                      </div>
                     
                    </el-form-item>
                 
                  </td>
                 
                  <td>
                    <el-form-item label="가입:" class="mb-0  formItem layerItem">
                     {{form.ref}} <span style="color:#999" class="ml-1">{{$t('msg.접속')}}:</span><span class="ml-2">{{form.mem_email}}</span>
                       <span style="color:#999" class="ml-1" v-if="form.sitetype=='4'">{{$t('msg.가입코드')}}:</span><span class="ml-2">{{form.reg_code}}</span>
                   
                  </el-form-item>

                  </td>
                </tr>
                 <tr>
                   <td>
                    <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem layerItem">
                    <el-input v-model="form.mem_hp" style="width:40%;margin-right:3px"></el-input>비번:<el-input v-model="form.mem_pw" style="width:40%"></el-input>
                 </el-form-item>
                  </td>
                   <td>
                      <el-form-item :label="$t('msg.닉네임')" class="mb-0 formItem layerItem">
                        <div class="d-flex">
                      <el-input v-model="form.mem_name" class="w-75"></el-input>
                      <el-color-picker v-model="form.color" size="mini" class="ml-2" style="margin-top: 3px;"></el-color-picker>
                    </div>
                   </el-form-item>
                  </td>
                 
                </tr>
                   <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td colspan="2">
                     <el-form-item class="mb-0 formItem layerItem d-flex myflex">
                   
              <span>{{$t('msg.한국경마')}}:</span><el-input v-model="form.event_pro"  style="width:30px; margin:0px 2px"></el-input>
              <span>{{$t('msg.한경삼복')}}:</span><el-input v-model="form.event_sambok"  style="width:30px; margin:0px 2px"></el-input>
              <span>{{$t('msg.한경쌍승')}}:</span><el-input v-model="form.event_sang"  style="width:30px; margin:0px 2px"></el-input>
                <span>{{$t('msg.한경복연')}}:</span><el-input v-model="form.event_bokyeon"  style="width:30px;margin:0px 2px"></el-input>

                 <span>{{$t('msg.일본경정')}}:</span><el-input v-model="form.event_pro_boat"  style="width:30px; margin:0px 2px"></el-input>
                <span>{{$t('msg.경정삼복')}}:</span><el-input v-model="form.event_boat_sambok"  style="width:30px;margin:0px 2px"></el-input>
               <span>{{$t('msg.일본경륜')}}:</span><el-input v-model="form.event_pro_cycle"  style="width:30px; margin:0px 2px"></el-input>
                <span>{{$t('msg.경륜삼복')}}:</span><el-input v-model="form.event_cycle_sambok"  style="width:30px; margin:0px 2px"></el-input>
              

                   
                  
                </el-form-item>
                 
                  </td>
                 
                </tr>
                 <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td colspan="2">
                     <el-form-item class="mb-0 formItem layerItem d-flex myflex">
                 
              <span>{{$t('msg.일본경마')}}:</span><el-input v-model="form.event_pro_japan"  style="width:30px; margin:0px 2px"></el-input>
                   <span>{{$t('msg.일경삼복')}}:</span><el-input v-model="form.event_japan_sambok"  style="width:30px; margin:0px 2px"></el-input>
                   <span>{{$t('msg.일경삼쌍')}}:</span><el-input v-model="form.event_japan_samsang"  style="width:30px; margin:0px 2px"></el-input>
                
                   
                  
                </el-form-item>
                 
                  </td>
                 
                </tr>
                 <tr v-if="form.sitetype==='1' || form.sitetype==='3' ">
                  <td>
                     

                              <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                              
                           
                              <el-form-item :label="$t('msg.롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom" style="width:30px;" class="mr-1"></el-input>
                                <span  class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom" style="width:30px;"></el-input> 
                                <span  class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_recom_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_recom_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                            </template>

                              <template v-else="">
                                 <el-form-item :label="$t('msg.롤링')"  class="mb-0 float-left formItem layerItem">
                                <span  class="mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing" style="width:30px;"></el-input>
                                <span class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group" style="width:30px;" ></el-input><span class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_s" style="width:30px;"></el-input><span class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                              
                                                            
                                                       
                               </template>

                  
                  </td>
                  <td>
                    <template v-if="form.out_bet_sadari_g==='100' " >
                    
                       <el-form-item :label="$t('msg.바치기')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.out_bet_power" style="width:40px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.out_bet_power_g" style="width:40px;"></el-input> <span  class="ml-2 mr-2">{{$t('msg.사다리')}}:</span><el-input v-model="form.out_bet_sadari" style="width:40px;"></el-input>
                     </el-form-item>
                     </template>

                     <template v-if="form.bg==='1' " >

                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                          <el-form-item :label="$t('msg.보글롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom1" style="width:30px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom1" style="width:30px;"></el-input> <span  class="ml-2 mr-2">{{$t('msg.사일')}} :</span><el-input v-model="form.event_loing_recom_s1" style="width:30px;"></el-input><span  class="ml-2 mr-2">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_recom_s1" style="width:30px;"></el-input>
                              </el-form-item>
                              
                           
                            
                              
                            </template>

                              <template v-else="">
                              
                              
                                <el-form-item  :label="$t('msg.보글롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class="mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing1" style="width:30px;"></el-input>
                                <span class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group1" style="width:30px;" ></el-input><span class="ml-2 mr-2">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_s1" style="width:30px;"></el-input><span class="ml-2 mr-2">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_s1" style="width:30px;"></el-input>
                              </el-form-item>                          
                                                       
                               </template>
                                </template>
                  </td>
                  
                </tr>
                 <tr v-if="form.sitetype==='4'">
                  <td colspan="1">
                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                             
                                <el-form-item :label="$t('msg.바카라롤링')" class="mb-0 float-left formItem layerItem">
                              <el-input v-model="form.event_loing_recom_e" style="width:60px;" class="mr-2"></el-input>
                              <span style="" class="ml-2 mr-2">{{$t('msg.슬롯롤링')}}:</span><el-input v-model="form.event_loing_recom_slot" style="width:50px;"></el-input>
                              </el-form-item>
                            </template>

                              <template v-else="">
                                                           
                                   <el-form-item :label="$t('msg.바카라롤링')"  class="mb-0 float-left formItem layerItem">
                                <el-input v-model="form.event_loing_e" style="width:60px;"></el-input>
                               
                                <span style="" class="ml-2 mr-2">{{$t('msg.슬롯롤링')}}:</span><el-input v-model="form.event_loing_slot" style="width:50px;"></el-input>
                              </el-form-item>                             
                                                                   
                               </template>
                  </td>

                  <td>
                     

                              <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                                 <el-form-item :label="$t('msg.파사롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom" style="width:30px;" class="mr-1"></el-input>
                                <span  class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom" style="width:30px;"></el-input> 
                                <span  class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_recom_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_recom_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                           
                            
                              
                            </template>

                              <template v-else="">
                                <el-form-item :label="$t('msg.파사롤링')"  class="mb-0 float-left formItem layerItem">
                                <span  class="mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing" style="width:30px;"></el-input>
                                <span class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group" style="width:30px;" ></el-input><span class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_s" style="width:30px;"></el-input><span class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                                                            
                                                       
                               </template>

                  
                  </td>
                  
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem layerItem">
                  <el-input v-model="form.mem_bankcode" style="width:105px;"></el-input> <span style="" class="ml-2 mr-2">{{$t('tableText.예금주')}}:</span><el-input v-model="form.mem_bankname" style="width:105px;"></el-input>
                </el-form-item>
                  
               
                  </td>
                  <td>
                     <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem layerItem">
                  <el-input v-model="form.mem_banknum"></el-input>
                </el-form-item>
                     
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('tableText.전용가상')"  class="mb-0 formItem layerItem">
                      <el-input v-model="form.mem_zip" class="w-50 mr-1"></el-input>
                      출금비번: <el-input v-model="form.mem_jumin" class="w-25"></el-input>
                    </el-form-item>
                    

                  </td>
                  <td>
                     <el-form-item  :label="$t('nav.배팅')"  class="mb-0 formItem layerItem">
                  <template v-if="form.sitetype!='4'">{{formatMoney(form.mem_all_init)}}</template>
                  <template v-if="form.sitetype=='4'">
                  <span class="ml-1 mr-1">{{$t('nav.카')}}:</span> {{formatMoney(form.mem_all_e)}}
                  <span class="ml-1 mr-1">{{$t('nav.슬')}}:</span> {{formatMoney(form.mem_all_slot)}}
                 <span class="ml-1 mr-1">{{$t('nav.파')}}:</span> {{formatMoney(form.mem_all_power)}}

                </template>
                  <!-- <el-button type="default" title="배팅누적리셋" size="mini" style="padding:2px;" class="mr-1" icon="el-icon-refresh" @click="resetMoney(4)"></el-button> -->
                    </el-form-item>
                    
                  </td>
                </tr>
                <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td>
                     <div class="d-flex">
                     <el-form-item :label="$t('nav.배팅한도')" class="mb-0 formItem layerItem">
                            <el-input v-model="form.max_bet"></el-input>
                          </el-form-item>
                           <el-form-item v-if="form.sitetype==='2' || form.sitetype==='3'" :label="$t('nav.딜레이')" class="mb-0 formItem layerItem">
                            <el-input v-model="form.t_delay"  style="width: 80px;"></el-input>
                          </el-form-item>
                    </div>
                  
                  </td>
                  <td>
                     <el-form-item :label="$t('nav.적중한도')" class="mb-0 formItem layerItem">
                             <el-select placeholder="선택" v-model="form.m_emoney" size="mini">
                                  <el-option
                                  v-for="item in statusoptions2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select>
                          </el-form-item>
                   
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.가입일')" class="mb-0 formItem layerItem">
                     {{form.mem_regdate}}
                    </el-form-item> 
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.배팅차단')" class="mb-0 formItem layerItem">
                     <template v-if="form.sitetype==='1' || form.sitetype==='3'">{{$t('msg.파워')}}<el-checkbox true-label="1" false-label="0" v-model="form.bet_black" style="margin-right:5px;"></el-checkbox></template>
                      <template v-if="form.sitetype==='2' || form.sitetype==='3'"><span style="margin-top:0px;">{{$t('msg.한경')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black1" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일륜')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black2" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일정')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black3" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일경')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black4" style="margin:0 5px;"></el-checkbox></template>
                    
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.입금')" class="mb-0 formItem layerItem">
                     <span class="text-danger">{{formatMoney(form.in_money)}}</span> <span style="" class="ml-1">{{$t('msg.출금')}}:</span><span class="ml-2 mr-2 text-primary">{{formatMoney(form.out_money)}}</span> 
                    </el-form-item>
                  
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.로그인전머니')" class="mb-0 formItem layerItem">
                       {{formatMoney(form.reset_money)}}
                      </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td>
                      <el-form-item :label="$t('msg.로그인회수')"  class="mb-0 formItem layerItem">
                        {{form.mem_login}} <el-button type="danger" size="mini" style="padding:2px;" class="ml-2 mr-2" :title="$t('msg.로그아웃처리')"  @click="mlogout()">{{$t('msg.팅기기')}}</el-button><!-- <span class="mr-2">중복로그인</span><el-select placeholder="선택" v-model="form.login_more" size="mini" style="width: 80px;">
                                  <el-option
                                  v-for="item in statusoptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select> -->
                      </el-form-item> 
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.가입IP')" class="mb-0 formItem layerItem">
                          <el-input type="textarea" :rows="1" v-model="form.mem_ip" style="width:30%"></el-input>
                                <span style="" class="ml-1">{{$t('msg.최종IP')}}:</span><el-input type="textarea" :rows="1" v-model="form.logip" class="w-50">
                                </el-input>
                         
                        </el-form-item>
                       
                  </td>
                </tr>
                  <tr>
                  <td>
                    <el-form-item :label="$t('msg.마지막로그인')" class="mb-0 formItem layerItem">
                       {{form.mem_login_date}}
                      </el-form-item>   
                     
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.마지막입금')" class="mb-0 formItem layerItem">
                       {{form.last_money_date}} <span style="color:#999;" class="ml-1">{{$t('nav.마지막출금')}}:</span>{{form.last_out_money_date}}
                      </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td colspan="2">
                    <el-form-item :label="$t('tableText.메모')" class="mb-0 formItem layerItem">
                        <el-input
                          type="textarea"
                          :rows="4"
                          v-model="form.mem_memo">
                        </el-input>
                     
                      </el-form-item>
                  </td>
                 
                </tr>
                              </table>
      
   
  

          </el-form>
          <div class="d-flex" style="justify-content: right;">
               <el-button type="primary" @click="Save" :disabled="disabled">{{$t('msg.수정')}}</el-button>
                <el-button @click="Cancel">Close</el-button>
          </div>

                </el-tab-pane>
                 <el-tab-pane  :label="$t('nav.로그인')"  name="tab2">
                   <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                               :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
    
                </div>

                  <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">
                  <el-table-column
                  :label="$t('nav.아이디')" width="100" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  :label="$t('tableText.아이피')" align="center" prop="vIP">
                </el-table-column>

                 <el-table-column
                 :label="$t('tableText.주소')"
                  align="center" prop="vReferer">
                </el-table-column>

                <el-table-column align="center" prop="add_time" :label="$t('tableText.시간')">
                </el-table-column>  
                
               
              
              </el-table>
             
                 </el-tab-pane>

                  <el-tab-pane :label="$t('tableText.머니변동')" v-if="form.sitetype=='4'" name="tab3">
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
    
                </div>
                      <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">
                <el-table-column
                   :label="$t('nav.아이디')" width=100 align="center" prop="mem_id">
                </el-table-column>

                  <el-table-column
                    :label="$t('tableText.변동금액')" width=100 align="center" prop="money">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                  <el-table-column
                 :label="$t('tableText.잔액')" align="center" prop="new_money">
                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                </el-table-column>
               
              

                <el-table-column
                  prop="doc" align="center"
                  :label="$t('tableText.메모')">
                  <template slot-scope="scope"><span>{{ scope.row.doc}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')">
                  
                </el-table-column>

                 
               
              
              </el-table>
                  </el-tab-pane>
                  <el-tab-pane  :label="$t('tableText.베팅롤링')"  v-if="form.sitetype=='4'" name="tab4">
                     <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.game_gubun"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                     <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value" :placeholder="$t('searchText.구분')" size="mini" style="width:80px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                  <div class="ml-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}} <span class="ml-2 mr-2">{{$t('msg.당첨')}}:{{formatMoney(total_emoney)}}</span> {{$t('msg.롤링')}}:{{formatMoney(total_rog)}}</div>
       
    
                </div>
                      <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">
                <el-table-column
                 :label="$t('nav.아이디')" width=100 align="center" prop="mem_id">
                </el-table-column>

                  <el-table-column
                   :label="$t('tableText.변동금액')" width=100 align="center" prop="money">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                 <el-table-column
                  :label="$t('tableText.잔액')"
                   align="center" prop="new_event">
                   <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'"><span>{{ formatMoney(scope.row.new_event) }}</span></template>
                </el-table-column>


               
                <el-table-column
                  prop="type" width=100 align="center"
                  :label="$t('searchText.구분')">
                  <template slot-scope="scope"><span>{{typeObj[scope.row.type]}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="doc" align="center"
                   :label="$t('tableText.메모')">
                  
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')">
                  
                </el-table-column>

                 
               
              
              </el-table>
                  </el-tab-pane>
                  <el-tab-pane  :label="$t('msg.입출금')" name="tab5">
                     <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                       <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value2"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                  <span class="ml-2">{{$t('msg.입금')}}:{{formatMoney(total_money)}} <span class="ml-2 mr-2">{{$t('msg.출금')}}:{{formatMoney(total_emoney)}}</span> {{$t('searchText.차액')}}:{{formatMoney(total_money-total_emoney)}}</span>
       
    
                </div>
                      <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">
                <el-table-column
                  :label="$t('nav.아이디')" align="center" prop="io_id">
                </el-table-column>

                 <el-table-column
                  :label="$t('searchText.구분')" align="center" prop="io_type">
                   <template slot-scope="scope">
                    <span class="text-danger" v-if="scope.row.io_type=='1'">{{$t('msg.입금')}}</span>
                    <span class="text-primary"v-if="scope.row.io_type=='2'">{{$t('msg.출금')}}</span>
                   </template>

                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')"  align="center" prop="io_money">

                  <template slot-scope="scope"><span class="text-primary">{{ scope.row.io_type=='1' ? formatMoney(scope.row.io_money):formatMoney(scope.row.io_out_money)}}</span></template>

                </el-table-column>

                  <el-table-column
                   :label="$t('tableText.이전잔액')"  align="center" prop="">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.io_jan)}}</span></template>
                   
                </el-table-column>


                <el-table-column
                  prop="io_regdate" align="center"
                  :label="$t('tableText.시간')">
                  
                </el-table-column>
                
               
              
              </el-table>
                  </el-tab-pane>
                 

                  <el-tab-pane :label="$t('tableText.알충환')" v-if="form.sitetype=='4'" name="tab6">
                     <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                      <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value3"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                     <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.game_gubun"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                               :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"  style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                  
                    <span class="ml-2">{{$t('searchText.알충')}}:{{formatMoney(ain)}} </span>
                   <span class="ml-2 mr-2">{{$t('searchText.알환')}}:{{formatMoney(aout)}}</span>
                   <span>{{$t('searchText.차액')}}:{{formatMoney(ain-aout)}}</span>

       
    
                </div>
                      <el-table
                :data="tabList"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  :label="$t('nav.아이디')" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  :label="$t('tableText.금액')"  align="center" prop="money">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                <el-table-column
                 :label="$t('msg.내용')" 
                   align="center" prop="doc">
                </el-table-column>

                <el-table-column
                 :label="$t('tableText.잔액')" align="center" prop="new_money">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                   
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')">
                  
                </el-table-column>
                  
               
              
              </el-table>
                  </el-tab-pane>

                

                   <el-tab-pane :label="$t('tableText.배팅카슬')"  name="tab7">
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd  HH:mm:ss" style="width:300px"  :default-time="['00:00:00','23:59:59']">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                   <div v-if="this.form.sitetype=='4'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('msg.카')}}:{{formatMoney(total_money_e)}} {{$t('nav.슬')}}:{{formatMoney(total_money_slot)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('msg.카')}}:{{formatMoney(total_emoney_e)}} {{$t('nav.슬')}}:{{formatMoney(total_emoney_slot)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span></div>

                   <div v-if="this.form.sitetype=='2'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span></div>
       
    
                </div>

                  <template v-if="this.form.sitetype=='4'">
                      <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">
               
                <el-table-column
                  :label="$t('nav.게임사')" align="center"  prop="provider_name">
                </el-table-column>
                 
                  <el-table-column
                  :label="$t('tableText.게임명')"
                   align="center" prop="game_title">
                </el-table-column>
                

                <el-table-column
                  prop="round_id" align="center"
                  label="ROUND-ID">
                </el-table-column>

                 <el-table-column
                  prop="tx_type" align="center" width=30
                  :label="$t('searchText.구분')">  
                </el-table-column>

                 <el-table-column
                  prop="bet" align="center" width=100
                  :label="$t('nav.배팅')">
                </el-table-column>
                <el-table-column
                  prop="win" align="center" width=100
                  :label="$t('msg.당첨')">
                </el-table-column>
               
                <el-table-column
                  prop="balance" align="center"
                  :label="$t('msg.잔고')">
                </el-table-column>
                <el-table-column
                  prop="create_at" align="center" width=70
                  :label="$t('msg.일시')">
                </el-table-column>
                <el-table-column
                  prop="txid" align="center"
                 :label="$t('msg.상세')">
                   <template slot-scope="scope">
        
                          <el-button type="danger" size="mini" @click="linkBtn(scope)">{{$t('msg.상세보기')}}</el-button>
 
                  </template>
                </el-table-column> 
              </el-table>
            </template>

                <template v-if="this.form.sitetype=='1'">
                                <el-table
                          :data="tabList"
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                           :label="$t('msg.회차')" align="center"  prop="buy_num">
                          </el-table-column>
                           
                            <el-table-column
                            :label="$t('searchText.구분')"  align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                            :label="$t('nav.배팅')">

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                           :label="$t('msg.배당')">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                           :label="$t('msg.당첨')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')"
                           >
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')" >
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                             :label="$t('msg.일시')">
                          </el-table-column>
                          
                          
                        </el-table>
                        </template>

                  </el-tab-pane>
                    <el-tab-pane :label="$t('msg.배팅파워')"  name="tab8">
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                   <div v-if="this.form.sitetype=='4'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('nav.단')}}:{{formatMoney(total_money_d)}}  {{$t('nav.조')}}:{{formatMoney(total_money_z)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('nav.단')}}:{{formatMoney(total_emoney_d)}} :{{$t('nav.조')}}{{formatMoney(total_emoney_z)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}} ({{$t('nav.단')}}:{{formatMoney(total_money_d-total_emoney_d)}} :{{$t('nav.조')}}{{formatMoney(total_money_z-total_emoney_z)}})</span></div>

                 
       
    
                </div>

                  <template v-if="this.form.sitetype=='4'">
                      <el-table
                          :data="tabList"
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                            :label="$t('msg.회차')" align="center"  prop="buy_num">

                            <template slot-scope="scope"><span class="text-primary">{{ scope.row.game_type}} {{ scope.row.buy_num}}</span></template>


                          </el-table-column>
                           
                            <el-table-column
                            :label="$t('searchText.구분')"  align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                             :label="$t('nav.배팅')">

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                            :label="$t('msg.배당')">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                            :label="$t('msg.당첨')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                             :label="$t('msg.이전롤링')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                            :label="$t('msg.일시')">
                          </el-table-column>
                          
                        </el-table>
            </template>

                <template v-if="this.form.sitetype=='1'">
                                <el-table
                          :data="tabList"
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                             :label="$t('msg.회차')" align="center"  prop="buy_num">
                          </el-table-column>
                           
                            <el-table-column
                            :label="$t('searchText.구분')"  align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                            :label="$t('nav.배팅')">

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                            :label="$t('msg.배당')">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                             :label="$t('msg.당첨')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                           <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                           :label="$t('msg.일시')">
                          </el-table-column>
                          
                        </el-table>
                        </template>

                  </el-tab-pane>
                   
              </el-tabs>
             
              <div v-if="tapId !=='0'" style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>
         
        <el-dialog
            :visible.sync="dialogVisible" :width="getW" class="idModel" :modal="modelFalse"  top="5vh" >
            <div class="border-bottom py-3"><span class="text-danger" style="font-size:16px">{{this.form.mem_id}} ({{this.form.mem_name}})</span></div>
            <el-table
                :data="memIdData"
                style="width: 100%" v-loading="loading" class="memTable">
                 <el-table-column
                  prop="date"
                  :label="$t('msg.날자')"
                  
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('msg.입금')"
                  >
                  <template slot-scope="scope">
                     {{formatMoney(scope.row.inm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="outm"
                  :label="$t('msg.출금')"
                  >
                   <template slot-scope="scope">
                     {{formatMoney(scope.row.outm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('searchText.차액')"
                  >
                  <template slot-scope="scope">
                     <span :class="scope.row.inm - scope.row.outm <0 ?'text-danger':'text-primary'">{{formatMoney(scope.row.inm - scope.row.outm)}}</span>
                  </template>
                </el-table-column>
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Close</el-button>
        
            </span>
          </el-dialog>
          <el-dialog
        :title="$t('searchText.쪽지보내기')"
          :width="customWidth" :modal="modelFalse" top="5vh"
          :visible.sync="creatModel">
           <div class="d-flex" v-loading="qaLoading">
          <div style="width:70%">
          <el-form ref="form" :model="memoform" label-width="100px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('nav.아이디')" class="mb-1">
              <el-input v-model="memoform.mem_id"></el-input>
            </el-form-item>
           
           <el-form-item :label="$t('msg.내용')" prop="content" class="mb-1">
               <el-input
                type="textarea"
                :rows="8"
                v-model="memoform.content">
              </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" class="float-right">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="memoSend()" class="float-right mr-2">{{$t('msg.확인')}}</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:25%;flex-direction:column;align-items:start">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
          <el-dialog
          :width="memWidth"
           :title="$t('msg.추천내역')" :modal="modelFalse"
          :visible.sync="reComModel"  top="5vh">
           <el-table
                :data="reComData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="mem_id"
                   :label="$t('msg.아이디닉네임')"
                  width="180">
                   <template slot-scope="scope">{{scope.row.mem_id}}({{scope.row.mem_name}}) {{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="mem_regdate"
                   :label="$t('msg.가입일')">
                  
                </el-table-column>
             
              </el-table>

         
          <span slot="footer" class="dialog-footer">
             <el-button @click="reComModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
          <el-dialog
  
          :visible.sync="getModel" :modal="modelFalse"  :width="getW">
          
          <el-form ref="getform" :model="getform" v-loading="loading">
            <div class="d-flex">
               <div class="boxflex">
                   <h2>{{$t('msg.사이트머니')}}</h2>
                   <p id="sitem">{{formatMoney(sitem)}} </p>
               </div>
               <div class="boxflex">
                   <h2>{{$t('msg.카지노슬롯머니')}}</h2>
                   <p id="apim">{{formatMoney(apim)}} </p>
               </div>
           </div>
            <div class="d-flex" style="width: 600px;">
            <el-form-item class="getItem mb-0">
               <el-select v-model="getvalue" size="mini" style="width:140px;" @change="getChange($event,1)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
             
            <el-form-item>
              <span class="ml-2 mr-2">{{$t('msg.에서')}}</span><el-input v-model="getform.site_cash" size="mini" style="width: 100px;"></el-input>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
               <el-select v-model="getapim" size="mini" style="width:140px;" @change="getChange($event,2)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
              <el-button type="primary" size="mini" @click="submitGetm" :disabled="disabled">{{$t('msg.전환하기')}}</el-button>
            </el-form-item>
          </div>
          </el-form>
         
       
        </el-dialog>
  </div>
</template>
<script>
 import layerchild from './layer-child.vue';
 import layoutLayer from './layout-layer.vue';
const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];


  export default{
    components: {
    
      layerchild,layoutLayer
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
      lydata:{
        type:Object,
        default:()=>{
          return {}
        }
      },

      
      visible: {
                type: Boolean,
                default: false
            },
  
    formobject: {
        type: Object,
        default: () => {}
    },
   
    
    },
    computed: {
          
            idDialogVisible: {
                get() {
                    return this.visible
                },
            },
            
        },
      data(){
        return{
            typeObj:{
                '1':this.$i18n.t("msg.배팅"), 
               '7':this.$i18n.t("msg.당첨"),
              '2':this.$i18n.t("msg.입금"),
              '3':this.$i18n.t("msg.출금"),
              '4':this.$i18n.t("msg.롤링전환"),
              '5':this.$i18n.t("msg.롤링지급"),
               '12':this.$i18n.t("msg.매장롤링"),
              '6':this.$i18n.t("msg.총판롤링"),
              '8':this.$i18n.t("msg.부본사롤링"),
              '9':this.$i18n.t("msg.회원롤링"),
              '10':this.$i18n.t("msg.알충전"),
              '11':this.$i18n.t("msg.알환전"),

               '13':this.$i18n.t("msg.롤링충전"),
              '14':this.$i18n.t("msg.롤링환전"),
             
              '21':this.$i18n.t("msg.사이트머니카지노머니전환"),
              '22':this.$i18n.t("msg.카지노머니사이트머니전환"),
             
              
 
            },
          total_emoney_e:'',
          total_emoney_slot:'',
           total_emoney:'',
          total_money:'',
           total_money_e:'',
          total_money_slot:'',
          total_rog:'',
           total_money_d:'',
            total_money_z:'',
             total_emoney_d:'',
              total_emoney_z:'',

           ain:'',
            aout:'',
           getW:'600px',
          getform:{
            site_cash:'',
          },
          getOptions:[
          {
              label:this.$i18n.t("msg.사이트머니"),
              value:'sitem'
            },
            {
              label:this.$i18n.t("msg.카지노슬롯머니"),
              value:'apim'
            },
            
          ],
          getvalue:'sitem',
          getapim:'apim',
          apim:'',
          sitem:'',
          getModel:false,
          formLoading:false,
          modelFalse:false,
            idsearchform:{
            time:[],
             idsearchOptions3:[
            {
              label:this.$i18n.t("msg.전체"),
              value:'1011'
            },
            {
              label:this.$i18n.t("msg.알충"),
              value:'10'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'11'
            },
           
            ],
            value3:'1011',
              idsearchOptions2:[
             {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.충전"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'2'
            },
           
            ],
            value2:'',
             idsearchOptions:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.당첨"),
              value:'7'
            },
            {
              label:this.$i18n.t("msg.롤링"),
              value:'5'
            }



            ],
            value:'',
             idsearchOptions1:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.파워볼"),
              value:'power'
            },
            {
              label:this.$i18n.t("searchText.카슬"),
              value:'api'
            },
           

            ],
            game_gubun:'',
          },
           pickerOptions: {
          },
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          idcurrentPage:1,
          idtotal:0,
          idsize:0,
          tabList:[],
          tapId:'0',
          tabname:'',
          activeIndex: 'tab1',
          memWidth:'500px',
          customWidth:'800px',
          reComModel:false,
         qaLoading:false,
          creatModel:false,
          checkAll: false,
          qa:[],
          reComData:[],
          level: [],
          cities: checkboxsOptions,
          isIndeterminate: true,
          domain:window.sessionStorage.getItem('domain'),
          userid:window.sessionStorage.getItem('userid'),
          memIdData:[],
          dialogVisible: false,
          disabled:false,
          loading:false,
          memoform:{
            mem_id:'',
            content:'',
          },
          form:{
            login_more:'0',
            api_money:0,
            power_cash:0,
            power_ecash:0,
            color:'',
            id_txt:'',
            bet_black:'',
            bet_black1:'',
            bet_black2:'',
            bet_black3:'',
            bet_black4:'',
            mem_name:'',
            mem_hp:'',
            mem_login:'',
            mem_id:'',
           

            mem_pw:'',
            mem_bankcode:'',
            mem_banknum: '',
            mem_bankname:'',
            mem_jumin:'',
            mem_zip:'',
            mem_regdate:'',
            mem_cash:'',
            mem_eventmoney:'',
            mem_ip:'',
            mem_raip:'',
            m_cp:'',
            mem_all_init:'',
             mem_all_e:'',
              mem_all_slot:'',
               mem_all_power:'',

            mem_memo:'',
            mem_status:'',
            m_emoney:'',
            loging:'',
            logip:'',
            mem_login_date:'',
            a_code:'',
            last_money_date:'',
            in_money:'',
            out_money:'',
            reset_money:'',

            event_loing:'',
            event_loing_recom:'',
            event_loing_group:'',
            event_loing_group_recom:'',
            event_loing_s:'',
            event_loing_recom_s:'',
            event_loing_group_s:'',
            event_loing_group_recom_s:'',


            event_loing1:'',
            event_loing_recom1:'',
            event_loing_group1:'',
            event_loing_group_recom1:'',
            event_loing_s1:'',
            event_loing_recom_s1:'',
            event_loing_group_s1:'',
            event_loing_group_recom_s1:'',



            event_boat_sambok: '',
            event_bokyeon: '',
            event_cycle_sambok: '',
            event_japan_sambok: '',
            event_japan_samsang: '',
            event_pro: '',
            event_pro_boat: '',
            event_pro_cycle: '',
            event_pro_japan: '',
            event_sambok: '',
            event_sang:'',


            event_loing_slot:'',
            event_loing_recom_slot:'',
            event_loing_e:'',
            event_loing_recom_e:'',

            last_out_money_date:'',
            reg_code:'',
            out_bet_power:'',
            out_bet_power_g:'',
            out_bet_sadari:'',
            out_bet_sadari_g:'',

           

            b_code:'',
        

          },
          urlLink:'https://blackstone-hk1.ppgames.net/gs2c/parentRoundHistoryDetails.do?playSessionId=10845692434823&stylename=blst_diamond2&hash=4d2fd93804bd9de97a2096e3317f719a&language=KO',
          level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")              
            },
            options: [{
            label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label:this.$i18n.t("msg.기본"),  
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }],
          memState:'',
          mem_status:'1',
          m_emoney:'',
          statusoptions: [{
             label: this.$i18n.t("msg.정상"),
              value: '1',
             
            },{
              label: this.$i18n.t("msg.탈퇴"),
               value: '0',
             
            }],
             statusoptions3: [{
              label: this.$i18n.t("msg.금지"),
              value: '0',
             
            },{
              label: this.$i18n.t("msg.가능"),
               value: '1',
             
            }],
            statusoptions2: [
            {
              label: '300만',
              value: '3000000',
             
            },
            {
              label: '500만',
              value: '5000000',
             
            },{
              label: '1000만',
               value: '10000000',
             
            },{
              label: '2000만',
               value: '20000000',
             
            }],
              rules: {
                  
                  content:[{ required: true, message: '', trigger: 'blur'}],
                },

        
           
          
        }
      },
      created() {
          // this.info.id父组件传给子组件的id值
          this.fetchManage(this.info.id);

          
             
    },
     computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
      
      methods:{
          bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
         openId(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layerchild,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
        getChange(v,type){
           var objVal = {}
              
             if(type=='1')
             {
                 if(v=='sitem')
                 {
                     this.getapim="apim"
                 }
                 if(v=='apim')
                 {
                     this.getapim='sitem'
                 }
             }
             if(type=='2')
             {
                 if(v=='sitem')
                 {
                     this.getvalue='apim'
                 }
                 if(v=='apim')
                 {
                     this.getvalue='sitem'
                 }
             }

              console.log(v)
              console.log(type)


        },
       
        submitGetm(){
          this.disabled = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/admin/exchange_gm_apim',
                  data:{
                    mem_id:this.form.mem_id,
                    cash:this.getform.site_cash,
                    type:this.getvalue
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false

                      if(response.data.code==200)
                            {
                                         this.$message.success(response.data.msg);
                                         this.getModel=false
                                         this.form.api_money = response.data.apimoney
                                         this.form.mem_cash = response.data.gamemoney
                                        // this.form.api_money = response.data.apimoney
                                         this.disabled = false
                            }else
                            {
                                         this.$message.error(response.data.msg);
                            }
                 
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })
        },
         getm(){
          this.getModel=true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getm?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false
                    console.log(response.data.data)
                  let data = response.data.data
                   this.apim = data.apimoney
                   this.sitem = data.gamemoney
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })

         },
          fetchManage(id){
            this.formLoading = true
            let token=window.sessionStorage.getItem('user');
            let that=this
            this.$axios({
                  method:'get',
                 
                   url:this.domain+'/admin/mem?fit='+this.prop+'&order='+this.order+'&mem_id='+id,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false
                   let data = response.data.data
               
                   this.form = {
                      id_txt: data.id_txt,
                      bet_black : data.bet_black,
                       sitetype:data.sitetype,
                         bg:this.bg,
                       ref:data.ref,
                        color:data.RaceYN,
                      mem_ing:data.mem_ing,
                      mem_name:data.mem_name,
                      api_money:data.api_money,
                      power_cash:data.power_cash,
                      power_ecash:data.power_ecash,
                      mem_hp:data.mem_hp,
                      mem_login:data.mem_login,
                      mem_id:data.mem_id,
                      mem_pw:data.mem_pw,
                      mem_bankcode:data.mem_bankcode,
                      mem_banknum: data.mem_banknum,
                      mem_bankname:data.mem_bankname,
                      event_boat_sambok : data.event_boat_sambok,
                      event_bokyeon : data.event_bokyeon,
                      event_cycle_sambok : data.event_cycle_sambok,
                      event_japan_sambok : data.event_japan_sambok,
                      event_japan_samsang : data.event_japan_samsang,
                      event_pro : data.event_pro,
                      event_pro_boat : data.event_pro_boat,
                      event_pro_cycle : data.event_pro_cycle,
                      event_pro_japan : data.event_pro_japan,
                      event_sambok : data.event_sambok,
                      event_sang : data.event_sang,
                      login_more : data.login_more,
                      mem_jumin:data.mem_jumin,
                       mem_email:data.mem_email,
                      mem_zip:data.mem_zip,
                      mem_regdate:data.mem_regdate,
                      mem_cash:data.mem_cash,
                      max_bet:data.max_bet,
                      m_emoney:data.m_emoney,
                      bet_black1 : data.bet_black1,
                      bet_black2 : data.bet_black2,
                      bet_black3 : data.bet_black3,
                      bet_black4 : data.bet_black4,
                      t_delay:data.t_delay,
                      mem_eventmoney:data.mem_eventmoney,
                      mem_ip:data.mem_ip,
                      mem_raip:data.mem_raip,
                      m_cp:data.m_cp,
                      mem_all_init:data.mem_all_init,

                       mem_all_e:data.mem_all_e,
                        mem_all_slot:data.mem_all_slot,
                         mem_all_power:data.mem_all_power,



                      mem_memo:data.mem_memo,
                      mem_status:data.mem_status,
                       memState:data.memState,
                      loging:data.loging,
                      logip:data.logip,
                      mem_login_date:data.mem_login_date,
                      a_code:data.a_code,
                      last_money_date:data.last_money_date,
                      in_money:data.in_money,
                      out_money:data.out_money,
                      reset_money:data.reset_money,

                      event_loing:data.event_loing,
                      event_loing_recom:data.event_loing_recom,
                      event_loing_group:data.event_loing_group,
                      event_loing_group_recom:data.event_loing_group_recom,

                      event_loing_s:data.event_loing_s,
                      event_loing_recom_s:data.event_loing_recom_s,
                      event_loing_group_s:data.event_loing_group_s,
                      event_loing_group_recom_s:data.event_loing_group_recom_s,



                      event_loing1:data.event_loing1,
                      event_loing_recom1:data.event_loing_recom1,
                      event_loing_group1:data.event_loing_group1,
                      event_loing_group_recom1:data.event_loing_group_recom1,

                      event_loing_s1:data.event_loing_s1,
                      event_loing_recom_s1:data.event_loing_recom_s1,
                      event_loing_group_s1:data.event_loing_group_s1,
                      event_loing_group_recom_s1:data.event_loing_group_recom_s1,



                      event_loing_recom_e:data.event_loing_recom_e,
                      event_loing_recom_slot:data.event_loing_recom_slot,
                      event_loing_e:data.event_loing_e,
                      event_loing_slot:data.event_loing_slot,
                      c_code:data.c_code,
                      last_out_money_date:data.last_out_money_date,
                      reg_code:data.reg_code,
                      out_bet_power:data.out_bet_power,
                      out_bet_power_g:data.out_bet_power_g,
                      out_bet_sadari:data.out_bet_sadari,
                      out_bet_sadari_g:data.out_bet_sadari_g,
                    
                      b_code:data.b_code,
                    }

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
      },
          handleTabClick(tab, event) {
              
                this.tabname=tab.name
              this.tapId=tab.index

               this.idsearchform.time=[];
               this.tabList=[];
                this.idcurrentPage=1
              this.getTablist();   
      },
      idsearchEvent(){

        this.getTablist();
        },

         qaChange(index){
         
         
         
          this.memoform.content = this.qa[index].contents
 
        },
        addRcom(){
          this.reComModel = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                  method:'get',
                   url:this.domain+'/admin/mem?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.loading = false
                   let data = response.data.data
                   console.log('recom:',data.recom)
                   this.reComData = data.recom
                  
              
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
        linkBtn(e){

 let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getGameCategory?dd='+e.row.create_at+'&txid='+e.row.txid,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             console.log('data====',response.data.data)

             if (typeof(response.data.data.DATA.detail_url) == "undefined")
             {
alert(this.$i18n.t("msg.지원안됩니다"));
             }else
             {
                 window.open(response.data.data.DATA.detail_url,'_blank')
             }
                 
                 
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          console.log(e);

          //window.open(this.urlLink,'_blank')
        },
        memoSend(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
           
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/memo_send',
                        data:{
                          content:this.memoform.content,
                          mem_id:this.memoform.mem_id,
                          level:this.level,
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                              
                            
                            this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            })
              
            
        },
        add(){

             console.log('test')
             let token=window.sessionStorage.getItem('user');
             this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqalist?type=memo',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //console.log('data====',response.data.data)
                  let item = response.data.data 
                  //this.form.content=''
                  this.qa = item
                  this.memoform.content=''
                  this.memoform.mem_id=this.form.mem_id
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          this.creatModel = true

        },
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
        memModel(){
          this.getData()
          this.dialogVisible = true
          this.loading = true
        },
          getTablist(){
               let s_time="";
               let e_time="";

               let v=this.tapId;
                 let ttname=this.tabname;

               if(this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }


            if(v=="0")
            {
               return;
            }
             this.loading = true
             let token=window.sessionStorage.getItem('user');
             let urls='';
             if(ttname=="tab2")
             {
                urls=this.domain+'/admin/acclist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab3")
             {
                urls=this.domain+'/admin/moneylogs_id?log=1&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab4")
             {
               urls=this.domain+'/admin/moneylogs_id?game_gubun='+this.idsearchform.game_gubun+'&type='+this.idsearchform.value+'&log=0&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab5")
             {
               urls=this.domain+'/admin/moneylist_id?io_type='+this.idsearchform.value2+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab6")
             {
               urls=this.domain+'/admin/moneylogs_id?type='+this.idsearchform.value3+'&game_gubun='+this.idsearchform.game_gubun+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab7")
             { 

             if(this.form.sitetype=='4')
             {
                urls=this.domain+'/admin/apibetlist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             if(this.form.sitetype=='1')
             {
                urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage;  
             }
             
           
           }else if(ttname=="tab8")
           { 

             if(this.form.sitetype=='4')
             {
                urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage;  
             }
             if(this.form.sitetype=='1')
             {
                urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage;  
             }
             
           
           }

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     //console.log('tabdata=',response.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data

                     this.ain = response.data.ain
                     this.aout = response.data.aout

                     this.total_emoney = response.data.total_emoney
                     this.total_rog = response.data.total_rog
                     this.total_money = response.data.total_money
                     this.total_money_e = response.data.total_money_e
                     this.total_money_slot = response.data.total_money_slot
                     this.total_emoney_e = response.data.total_emoney_e
                     this.total_emoney_slot = response.data.total_emoney_slot

                      this.total_money_d = response.data.total_money_d
                     
                      this.total_money_z = response.data.total_money_z

                       this.total_emoney_d = response.data.total_emoney_d
                     
                      this.total_emoney_z = response.data.total_emoney_z
                   

                     this.loading = false

                   
               
            }).catch((error) =>{
               this.loading = false
               
            })
        },
         idhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
               this.idsize = val
              this.getTablist();
              this.loading= true

            },
            idhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.idcurrentPage = val
              this.getTablist();
              this.loading= true
            },
        getData(){
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/mem_by_inout_date?mem_id='+this.form.mem_id;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('data=',response.data)
                     let data = response.data.data
                     this.memIdData =data
                     let inmoney=0;
                     let outmoney=0;
                     data.map(function(item)
                     {
                        inmoney+=parseInt(item.inm)
                        outmoney+=parseInt(item.outm)
                     })

                     let total={date: this.$i18n.t("msg.합계"), inm: inmoney, outm: outmoney};

                     this.memIdData.push(total);
                     this.loading = false

                   
               
            }).catch((error) =>{
              // if(error.response.status==401)
              // {
              //   this.$router.push({name:'login'})

              // }
                console.log('error',error.response)       //请求失败返回的数据
               
            })
        },

        Cancel(){
           this.$layer.close(this.layerid);
        },

        // Save() {
      //           this.$emit('submitData')
      //       },
        Save(){
          this.$confirm(this.$i18n.t("msg.수정하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.수정"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          this.disabled = true
              this.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_up',
                      data:this.form,   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                   // console.log('response',response);

                   if(response.data.code==200){
                       this.disabled = false
                       this.formLoading = false
                       this.$layer.close(this.layerid);
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      this.disabled = false
                      this.$parent.formLoading = false
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:  this.$i18n.t("msg.취소됨"),
          });          
        });
              
     
        },
         apiMoney(type){
            
        
          let token=window.sessionStorage.getItem('user');
          let that=this;
          this.$axios({
                      method:'get',
                      url:this.domain+'/admin/getapimoney?mem_id='+this.form.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                  
                    if(response.data.code==200){

                       this.$message({
                      message:this.$i18n.t("msg.갱신완료"),
                      type:'success'
                    })
                     
                      that.form.api_money=response.data.data
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      
                  })
        },

          resetMoney(type){
            let mtype='';
                     if(type==1)
                      {
                        mtype=this.$i18n.t("msg.게임머니");
                      }
                      else if(type==2)
                      {
                     
                       mtype=this.$i18n.t("msg.이벤트머니"); 
                        
                      }
                      else if(type==3)
                      {
                        mtype=this.$i18n.t("msg.롤링머니");
                      }
                      else if(type==4)
                      {
                        mtype=this.$i18n.t("msg.배팅누적");
                      }


          this.$confirm(mtype+this.$i18n.t("msg.리셋하시겠습니까"), this.$i18n.t("msg.알림"), {
      
          confirmButtonText: this.$i18n.t("msg.취소"),
          cancelButtonText: this.$i18n.t("msg.리셋"),
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/reset_money',
                      data:{
                      mem_id:this.form.mem_id,
                      type:type
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      if(type==1)
                      {
                       this.form.mem_cash = '0'
                      }
                      else if(type==2)
                      {
                       this.form.mem_eventmoney='0'
                        
                        
                      }
                      else if(type==3)
                      {
                       this.form.mem_ing='0'
                      }
                      else if(type==4)
                      {
                       this.form.mem_all_init='0'
                      }
                      
                     
              
                      //this.$parent.getList()
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨"),
          });          
        });

     
        },
        mlogout(){
          
                     


          this.$confirm(this.form.mem_id+this.$i18n.t("msg.아웃하시겠습니까"), this.$i18n.t("msg.알림"), {
      
              confirmButtonText: this.$i18n.t("msg.취소"),
          cancelButtonText: this.$i18n.t("msg.아웃"),
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_out',
                      data:{
                      mem_id:this.form.mem_id
                      
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                       this.form.loging='0'
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

     
        },
        
        handleClose() {
                this.$emit('handleClose')
            },

      
      }
  }
</script>
<style>
/deep/ .el-dialog__body{
  padding:5px 10px;
}
/deep/ .el-dialog__header{
  padding:2px 20px 10px
}
.flexNo{
  display: block;
}
.myflex{
  margin-left: -80px;
}
>>>.el-tabs__header{
  margin-bottom: 5px;
}.boxflex {
  
    color: #3d3a3a;
    border: 1px solid #f1f1f1;
    width: 98%;
    text-align: center;
    margin-bottom: 10px;
  
}

.boxflex h2 {
    color: #2c2b2b;
    font-size: 14px;
    background-color: #e4e4e4;
    height: 32px;
    line-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/layer-child-new.vue